import { useEffect } from 'react'
import { createFileRoute, Outlet } from '@tanstack/react-router'

import { LoggedInLayout } from '@/components/layout/logged-in-layout.tsx'
import { useAuth } from '@/features/auth/use-auth.ts'

export const Route = createFileRoute('/_authenticated')({
  component: AuthenticatedLayout,
})

function AuthenticatedLayout() {
  const auth = useAuth()
  const navigate = Route.useNavigate()

  useEffect(() => {
    if (!auth.user && !auth.loading) {
      navigate({ to: '/auth/login' })
    }
  }, [auth.loading, auth.user, navigate])

  return <LoggedInLayout>{auth.session && <Outlet />}</LoggedInLayout>
}
